var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c("v-data-table", {
        staticStyle: { width: "100%" },
        attrs: {
          headers: _vm.headers,
          items: _vm.entries,
          page: _vm.pagination.page,
          "items-per-page": _vm.pagination.rowsPerPage,
          "items-per-page-text": _vm.$t("tables.RowsPerPage"),
          "items-per-page-items": [5, 10],
          "header-props": { sortIcon: "mdi-menu-down" },
          "footer-props": {
            prevIcon: "mdi-menu-left",
            nextIcon: "mdi-menu-right"
          }
        },
        on: {
          "update:page": function($event) {
            return _vm.$set(_vm.pagination, "page", $event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(props.item.bt_num_pol))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(props.item.bt_floor))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(props.item.bt_fraction))]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(_vm._s(_vm.getTypeName(props.item.bt_type)))
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(props.item.bt_description))]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(props.item.bt_address))]),
                  _vm._v(" "),
                  !_vm.disabled
                    ? _c(
                        "td",
                        [
                          _c("app-datatable-action-buttons", {
                            attrs: {
                              "user-can-edit": true,
                              "user-can-delete": true
                            },
                            on: {
                              edit: function($event) {
                                return _vm.startEditingItem(props.item)
                              },
                              delete: function($event) {
                                return _vm.deleteItem(props.item)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _vm.itemEditionDialog
        ? _c("typification-edition-dialog", {
            attrs: {
              open: _vm.itemEditionDialog,
              "original-item": _vm.itemToEdit
            },
            on: { close: _vm.closeItemEdition, edit: _vm.editItem }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ca89a6b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca89a6b4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Buildings/Typification/TypificationTable.vue
// module id = null
// module chunks = 